webpackJsonp([270710348363565],{

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.StrongListDocument = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    h1 {\n      font-size: 1.55rem;\n    }\n  '], ['\n    h1 {\n      font-size: 1.55rem;\n    }\n  ']);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _constants = __webpack_require__(8);
	
	var _Breakpoints = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StrongListDocument = exports.StrongListDocument = _styledComponents2.default.article.withConfig({
	  displayName: 'StrongListDocument',
	  componentId: 'sc-645d03-0'
	})(['color:', ';max-width:68ch;line-height:1.65;overflow-wrap:anywhere;a,a:link,a:visited{color:', ';text-decoration:none;}a:hover{text-decoration:underline;}h1{font-size:1.8rem;line-height:1.2;margin:0 0 1rem;}h2{font-size:1.25rem;line-height:1.3;margin:1.75rem 0 0.6rem;}h3{font-size:1.05rem;line-height:1.35;margin:1.25rem 0 0.35rem;}p,ul{margin:0 0 1rem;}ul{padding-left:1.2rem;}li + li{margin-top:0.35rem;}code{font-family:Consolas,Monaco,\'Andale Mono\',monospace;font-size:0.92em;}.meta p{margin-bottom:0.35rem;}nav{display:flex;flex-wrap:wrap;gap:0.25rem 1rem;margin:0 0 1.5rem;}nav a{display:inline-flex;align-items:center;min-height:44px;}section + section{margin-top:2.5rem;padding-top:1.5rem;border-top:1px solid ', ';}', ';'], _constants.colors.darkTextColor, _constants.colors.linkColor, _constants.colors.bordersColor, _Breakpoints.media.phone(_templateObject));
	
	var LanguageNav = function LanguageNav() {
	  return _react2.default.createElement(
	    'nav',
	    { 'aria-label': 'Language' },
	    _react2.default.createElement(
	      'a',
	      { href: '#en' },
	      'English'
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: '#es' },
	      'Espa\xF1ol'
	    )
	  );
	};
	
	exports.default = LanguageNav;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _StrongListDocument = __webpack_require__(56);
	
	var _StrongListDocument2 = _interopRequireDefault(_StrongListDocument);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var contactEmail = 'stronglist@robertovg.com';
	
	var PrivacyPage = function PrivacyPage() {
	  return _react2.default.createElement(
	    _StrongListDocument.StrongListDocument,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'StrongList Privacy Policy - Roberto V\xE1zquez Gonz\xE1lez Site',
	      meta: [{ name: 'robots', content: 'noindex' }, {
	        name: 'description',
	        content: 'Privacy policy for the StrongList iOS app. English and Spanish.'
	      }]
	    }),
	    _react2.default.createElement(
	      'h2',
	      { className: 'general__pageTitle' },
	      'StrongList privacy'
	    ),
	    _react2.default.createElement(_StrongListDocument2.default, null),
	    _react2.default.createElement(
	      'section',
	      { id: 'en', lang: 'en' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'StrongList Privacy Policy'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'meta' },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Effective date:'
	          ),
	          ' October 22, 2026'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Who is responsible:'
	          ),
	          ' Roberto V\xE1zquez Gonz\xE1lez'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Contact:'
	          ),
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:' + contactEmail },
	            contactEmail
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'The short version'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'StrongList doesn\'t collect your data. There is no account, no analytics, no advertising, no tracking and no server of ours. The workouts you log stay on your device and, if iCloud sync is on, in your own iCloud Drive. We, the developer, never receive or see them.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'What StrongList stores, and where'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Everything you enter in StrongList is training data you type in yourself: gyms (name, whether machines are numbered, machine numbers), exercises and custom exercises (name, muscle group, type), plans (name, targets such as sets, reps, weight, duration and distance) and sessions (date, start and end time, gym, what you logged). StrongList has no free-text notes field, and it doesn\'t ask for your name, email, phone number, photos, contacts, location or health data.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'On your device.'
	        ),
	        ' This data is kept in the app\'s local database on your iPhone or iPad. Your settings (language, kg/lb, default values, the gym you used last and similar preferences) are kept in the app\'s local settings.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'In your own iCloud Drive (optional).'
	        ),
	        ' If iCloud sync is on, StrongList also writes your training data as readable JSON files to the app\'s folder in your iCloud Drive (Files \u203A iCloud Drive \u203A StrongList), so your devices stay in step. Sync is on by default and you can turn it off at any time in StrongList \u203A Settings. These files live in your iCloud account, under Apple\'s terms and',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://www.apple.com/legal/privacy/', target: '_blank', rel: 'noopener noreferrer' },
	          'Apple\'s Privacy Policy'
	        ),
	        '. We can\'t access them.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'To tell your devices apart during sync, each file records when it was changed, the device type ("iPhone" or "iPad") and a random identifier that StrongList creates on that device. That identifier is not your device\'s advertising ID or any Apple identifier, and it is only stored in your own files. On the device, StrongList also keeps a small sync status file that includes a one-way hash (SHA-256) of your iCloud identity token, so it can notice when you switch iCloud accounts. The token itself isn\'t stored, and StrongList never reads your Apple Account name or email.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Live Activity.'
	        ),
	        ' While a workout is running, StrongList can show it on the Lock Screen and in the Dynamic Island (plan name, elapsed time, progress and next exercise). That content stays on the device and ends when the workout ends. Anyone who can see your screen can see it. You can turn Live Activities off in iOS Settings.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Importing a routine with your own AI app'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'When you create a plan, StrongList can copy a ready-made prompt to your clipboard. If you choose to, you paste that prompt, together with a photo or text of your routine, into an AI app of your choice, then paste its reply back into StrongList. StrongList has no built-in AI and sends nothing in this process. The prompt contains no personal data. Whatever you share with the other app is handled by that app\'s provider under their own privacy policy.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'What we don\'t do'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'No account or sign-in.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'No analytics, crash-reporting, advertising or other third-party SDKs.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'No tracking across apps or websites, and no data sold or shared with data brokers.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'No servers of our own: StrongList doesn\'t send your data to us or to anyone else. The only off-device copy is the optional sync to your own iCloud Drive.'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Purchases and Apple services'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'StrongList is sold through the App Store. Apple handles payment, and we don\'t receive your payment details. Apple may provide developers with aggregated sales and usage reports, and with crash reports only if you have chosen to share them with developers in iOS Settings. That is governed by Apple\'s privacy policy.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Keeping and deleting your data'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Your data stays until you delete it:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'In the app you can delete sessions, and archive and then delete plans. Custom exercises can be deleted in Settings.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Deleting StrongList from a device removes its local data from that device.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'If you used iCloud sync, your files remain in your iCloud Drive until you delete them: open Files \u203A iCloud Drive \u203A StrongList, or manage the app\'s iCloud data in iOS Settings. This folder may include a "Conflicts" folder holding older copies kept when two devices edited the same item.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Because we hold no copy of your data, there is nothing for us to export or delete on our side. You can still contact us with any question.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Children'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'StrongList doesn\'t collect personal data from anyone, children included.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'If you email us'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If you write to ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:' + contactEmail },
	          contactEmail
	        ),
	        ', we receive your email address and message and use them only to reply to you. Emails are kept only as long as needed to answer your request and are then deleted.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Your rights'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Depending on where you live (for example under the EU General Data Protection Regulation), you have rights such as access, correction, deletion and objection. Since we don\'t hold your training data, you exercise most of them directly in the app or in your iCloud Drive. For anything else, contact ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:' + contactEmail },
	          contactEmail
	        ),
	        '. You can also complain to your data protection authority (in Spain, the Agencia Espa\xF1ola de Protecci\xF3n de Datos, www.aepd.es).'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Changes'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'If this policy changes, we\'ll update this page and its effective date. If StrongList ever starts collecting data, we\'ll say so here and in the App Store privacy details before that version ships.'
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'es', lang: 'es' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Pol\xEDtica de privacidad de StrongList'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'meta' },
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Fecha de entrada en vigor:'
	          ),
	          ' 22 de octubre de 2026'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Responsable:'
	          ),
	          ' Roberto V\xE1zquez Gonz\xE1lez'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'strong',
	            null,
	            'Contacto:'
	          ),
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'mailto:' + contactEmail },
	            contactEmail
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'En pocas palabras'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'StrongList no recoge tus datos. No hay cuenta, ni anal\xEDtica, ni publicidad, ni seguimiento, ni ning\xFAn servidor nuestro. Los entrenamientos que apuntas se quedan en tu dispositivo y, si tienes activada la sincronizaci\xF3n con iCloud, en tu propio iCloud Drive. Nosotros, el desarrollador, no los recibimos ni los vemos nunca.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Qu\xE9 guarda StrongList y d\xF3nde'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Todo lo que metes en StrongList son datos de entrenamiento que escribes t\xFA: gimnasios (nombre, si las m\xE1quinas est\xE1n numeradas, n\xFAmeros de m\xE1quina), ejercicios y ejercicios personalizados (nombre, grupo muscular, tipo), planes (nombre y objetivos como series, repeticiones, peso, duraci\xF3n y distancia) y sesiones (fecha, hora de inicio y fin, gimnasio y lo que has apuntado). StrongList no tiene un campo de notas libres y no te pide nombre, email, tel\xE9fono, fotos, contactos, ubicaci\xF3n ni datos de salud.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'En tu dispositivo.'
	        ),
	        ' Estos datos se guardan en la base de datos local de la app en tu iPhone o iPad. Tus ajustes (idioma, kg/lb, valores por defecto, el \xFAltimo gimnasio usado y preferencias similares) se guardan en los ajustes locales de la app.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'En tu propio iCloud Drive (opcional).'
	        ),
	        ' Si la sincronizaci\xF3n con iCloud est\xE1 activada, StrongList tambi\xE9n guarda tus datos de entrenamiento como archivos JSON legibles en la carpeta de la app en tu iCloud Drive (Archivos \u203A iCloud Drive \u203A StrongList), para que tus dispositivos est\xE9n al d\xEDa. Viene activada por defecto y puedes desactivarla cuando quieras en StrongList \u203A Ajustes. Esos archivos est\xE1n en tu cuenta de iCloud, bajo las condiciones y la',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://www.apple.com/es/legal/privacy/',
	            target: '_blank',
	            rel: 'noopener noreferrer'
	          },
	          'pol\xEDtica de privacidad de Apple'
	        ),
	        '. Nosotros no tenemos acceso a ellos.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Para distinguir tus dispositivos al sincronizar, cada archivo registra cu\xE1ndo se modific\xF3, el tipo de dispositivo ("iPhone" o "iPad") y un identificador aleatorio que StrongList crea en ese dispositivo. Ese identificador no es el identificador de publicidad ni ning\xFAn identificador de Apple, y solo se guarda en tus propios archivos. En el dispositivo, StrongList guarda adem\xE1s un peque\xF1o archivo de estado de la sincronizaci\xF3n con un resumen irreversible (SHA-256) del identificador de tu cuenta de iCloud, para detectar si cambias de cuenta. El identificador en s\xED no se guarda, y StrongList nunca lee el nombre ni el email de tu cuenta de Apple.'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'strong',
	          null,
	          'Actividad en directo.'
	        ),
	        ' Mientras hay un entreno en curso, StrongList puede mostrarlo en la pantalla bloqueada y en la Dynamic Island (nombre del plan, tiempo, progreso y siguiente ejercicio). Ese contenido se queda en el dispositivo y desaparece al terminar el entreno. Cualquiera que vea tu pantalla puede verlo. Puedes desactivar las actividades en directo en los Ajustes de iOS.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Importar una rutina con tu propia app de IA'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Al crear un plan, StrongList puede copiar unas instrucciones (un prompt) ya preparadas al portapapeles. Si quieres, las pegas junto con una foto o el texto de tu rutina en la app de IA que elijas y luego pegas su respuesta en StrongList. StrongList no lleva IA integrada y no env\xEDa nada en este proceso. Las instrucciones no contienen datos personales. Lo que compartas con la otra app lo gestiona su proveedor seg\xFAn su propia pol\xEDtica de privacidad.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Lo que no hacemos'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'No hay cuenta ni inicio de sesi\xF3n.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'No hay SDK de anal\xEDtica, informes de fallos, publicidad ni de terceros.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'No hay seguimiento entre apps o webs, y no vendemos ni cedemos datos a intermediarios de datos.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'No tenemos servidores propios: StrongList no nos env\xEDa tus datos ni a nosotros ni a nadie. La \xFAnica copia fuera del dispositivo es la sincronizaci\xF3n opcional con tu propio iCloud Drive.'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Compras y servicios de Apple'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'StrongList se vende a trav\xE9s del App Store. El pago lo gestiona Apple y nosotros no recibimos tus datos de pago. Apple puede facilitar a los desarrolladores informes agregados de ventas y uso, e informes de fallos solo si has elegido compartirlos con los desarrolladores en los Ajustes de iOS. Todo ello se rige por la pol\xEDtica de privacidad de Apple.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Conservaci\xF3n y borrado'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Tus datos se conservan hasta que los borras:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'En la app puedes eliminar sesiones y archivar y despu\xE9s eliminar planes. Los ejercicios personalizados se eliminan desde Ajustes.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Al eliminar StrongList de un dispositivo se borran sus datos locales en ese dispositivo.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Si usaste la sincronizaci\xF3n con iCloud, tus archivos siguen en tu iCloud Drive hasta que los borres: abre Archivos \u203A iCloud Drive \u203A StrongList o gestiona los datos de iCloud de la app en los Ajustes de iOS. La carpeta puede incluir una subcarpeta "Conflicts" con copias antiguas guardadas cuando dos dispositivos editaron lo mismo.'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Como no tenemos ninguna copia de tus datos, no hay nada que exportar ni borrar por nuestra parte. Aun as\xED, puedes escribirnos con cualquier duda.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Menores'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'StrongList no recoge datos personales de nadie, tampoco de menores.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Si nos escribes'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Si escribes a ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:' + contactEmail },
	          contactEmail
	        ),
	        ', recibimos tu direcci\xF3n y tu mensaje y los usamos solo para responderte. Los emails se conservan solo el tiempo necesario para atender tu consulta y despu\xE9s se borran.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Tus derechos'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Seg\xFAn d\xF3nde vivas (por ejemplo, con el Reglamento General de Protecci\xF3n de Datos de la UE), tienes derechos como el de acceso, rectificaci\xF3n, supresi\xF3n u oposici\xF3n. Como no tenemos tus datos de entrenamiento, la mayor\xEDa los ejerces directamente en la app o en tu iCloud Drive. Para cualquier otra cosa, escribe a',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:' + contactEmail },
	          contactEmail
	        ),
	        '. Tambi\xE9n puedes reclamar ante la Agencia Espa\xF1ola de Protecci\xF3n de Datos (www.aepd.es).'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Cambios'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Si esta pol\xEDtica cambia, actualizaremos esta p\xE1gina y su fecha. Si alg\xFAn d\xEDa StrongList empezara a recoger datos, lo diremos aqu\xED y en los detalles de privacidad del App Store antes de publicar esa versi\xF3n.'
	      )
	    )
	  );
	};
	
	exports.default = PrivacyPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-stronglist-privacy-js-8f647d5c73a4cd798171.js